import { ITimeSettings } from '../definitions/Shared'
import moment from 'moment'
import Helper from './Helper'

const TimeHelper = {
    timeSettings: (): ITimeSettings => ({ from: '2023-01-01', to: '2023-12-31', granularity: 'month', template: 'custom' }),
    stringify: (settings: ITimeSettings): string => {
        if (!settings) return 'empty'
        return [(settings.from ?? ''), (settings.to ?? ''), settings.granularity ?? '', settings.template ?? ''].join('_')
    },
    formatDateToYYYYMMDD(date: Date): string {
        if (!Helper.hasVal(date)) return ''
        if (typeof (date) === 'string') return date as string

        const year = date.getFullYear()
        const month = ('0' + (date.getMonth() + 1)).slice(-2)
        const day = ('0' + date.getDate()).slice(-2)

        return `${year}-${month}-${day}`
    },
    now(): moment.Moment {
        return moment.utc()
    },
    timeOrderedGroups: ['Today', 'Yesterday', 'Last Week', 'Last Month', 'Last Quarter', 'Last Year', 'Old'],
    formatDateDifference(date: string): string {
        const today = new Date()
        const inputDate = new Date(date)

        if (inputDate.toDateString() === today.toDateString()) {
            return this.timeOrderedGroups[0]
        }

        const diffTime = Math.abs(today.getTime() - inputDate.getTime())
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays === 1) {
            return this.timeOrderedGroups[1]
        }

        const startOfLastWeek = moment().subtract(1, 'weeks').startOf('week').toDate()
        const startOfLastMonth = moment().subtract(1, 'months').startOf('month').toDate()
        const startOfLastQuarter = moment().subtract(1, 'quarters').startOf('quarter').toDate()
        const startOfLastYear = moment().subtract(1, 'years').startOf('year').toDate()

        if (inputDate > startOfLastWeek) {
            return this.timeOrderedGroups[2]
        }

        if (inputDate > startOfLastMonth) {
            return this.timeOrderedGroups[3]
        }

        if (inputDate > startOfLastQuarter) {
            return this.timeOrderedGroups[4]
        }

        if (inputDate > startOfLastYear) {
            return this.timeOrderedGroups[5]
        }

        return this.timeOrderedGroups[6]
    },

    toUTCDateString(date: Date): string {
        if (!(date instanceof Date)) return ''
        const year = date.getUTCFullYear()
        const month = String(date.getUTCMonth() + 1).padStart(2, '0')
        const day = String(date.getUTCDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    },
    getWorkingDatePlusDays(startDate: Date, days: number): Date {
        const result: Date = startDate
        let addedDays = 0

        while (addedDays < days) {
            result.setDate(result.getDate() + 1)
            const dayOfWeek = result.getDay()
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                addedDays++
            }
        }
        return result
    },
    isChristmas() {
        const currentDate = new Date()
        const startDate = new Date(currentDate.getFullYear(), 11, 1)
        const endDate = new Date(currentDate.getFullYear() + 1, 0, 1)
        return currentDate >= startDate && currentDate <= endDate
    }

}

export default TimeHelper
